import { CalculationCreateRouteView } from './view';

export const createRoute = {
  path: 'create',
  element: <CalculationCreateRouteView/>
};